import React from 'react';

import { useIntl } from 'react-intl';

import AppStoreBadge from 'components/app-store-badge';
import ExternalLink from 'components/external-link';
import GooglePlayBadge from 'components/google-play-badge';
import Picture from 'components/picture';
import { isNative } from 'utils/environment';

import {
  AppStoreBadgeContainer,
  BadgeImage,
  BadgesContainer,
  Description,
  Disclaimer,
  GooglePlayBadgeContainer,
  Header,
  HuaweiBadgeContainer,
  HuaweiImage,
  ImageHalf,
  MainImageContainer,
  Section,
  SuperHeader,
  TextContainer,
  TextHalf,
  appleBadgeStyles,
  googleBadgeStyles,
} from './styled';
import BackgroundPicture from './styled/background-picture';
import { IAppDownloadProps } from './types';

const AppDownloadSection: React.FC<IAppDownloadProps> = ({ item: appDownloadSection, loading }) => {
  const { formatMessage } = useIntl();
  const {
    androidDownloadImage,
    androidDownloadLink,
    iOSDownloadImage,
    iOSDownloadLink,
    huaweiDownloadImage,
    huaweiDownloadLink,
    backgroundImage,
    headerSuperText,
    header,
    copy,
    primaryImage,
  } = appDownloadSection || {};

  if (isNative || loading) {
    return null;
  }

  return (
    <Section>
      {backgroundImage && (
        <BackgroundPicture image={backgroundImage} objectFitContain={false} alt="" />
      )}
      <TextHalf>
        <TextContainer>
          <SuperHeader>{headerSuperText?.locale}</SuperHeader>
          <Header>{header?.locale}</Header>
          <Description>{copy?.locale}</Description>
          <BadgesContainer>
            <AppStoreBadgeContainer badgeStyles={appleBadgeStyles}>
              <ExternalLink data-testid="iOS-download-link" href={iOSDownloadLink || ''}>
                {iOSDownloadImage?.locale ? (
                  <BadgeImage image={iOSDownloadImage.locale} alt="" />
                ) : (
                  <AppStoreBadge width={160} height={45} withBorder={false} />
                )}
              </ExternalLink>
            </AppStoreBadgeContainer>
            <GooglePlayBadgeContainer badgeStyles={googleBadgeStyles}>
              <ExternalLink data-testid="android-download-link" href={androidDownloadLink || ''}>
                {androidDownloadImage?.locale ? (
                  <BadgeImage image={androidDownloadImage?.locale} alt="" />
                ) : (
                  <GooglePlayBadge width={160} height={45} withBorder={false} />
                )}
              </ExternalLink>
            </GooglePlayBadgeContainer>
            {huaweiDownloadImage?.locale && (
              <HuaweiBadgeContainer badgeStyles={googleBadgeStyles}>
                <ExternalLink data-testid="huawei-download-link" href={huaweiDownloadLink || ''}>
                  <HuaweiImage image={huaweiDownloadImage?.locale} alt="" />
                </ExternalLink>
              </HuaweiBadgeContainer>
            )}
          </BadgesContainer>
          <Disclaimer>{formatMessage({ id: 'phoneAppStoresDisclaimers' })}</Disclaimer>
        </TextContainer>
      </TextHalf>
      <ImageHalf>
        <MainImageContainer>
          {primaryImage?.locale && <Picture image={primaryImage?.locale} alt="" objectFitContain />}
        </MainImageContainer>
      </ImageHalf>
    </Section>
  );
};

export default AppDownloadSection;
